module.exports = __webpack_public_path__ + "static/media/4.16d1a46b.png";